export const GET_CMS_MAIN_MENU = "GET_CMS_MAIN_MENU";
export const GET_CMS_MAIN_MENU_ERROR = "GET_CMS_MAIN_MENU_ERROR";